<template>
	<div id="app" v-if="project">
		<NavBarProject :project="project" />
		<b-container class="menu-height text-left" v-if="apartments">
			<b-row>
				<b-col>
					<h4 class="mt-5"><b>PLANTAS</b></h4>
				</b-col>
				<b-col class="text-right">
					<b-img :src="project.logo_url" height="150px" alt="image" />
				</b-col>
			</b-row>
			<b-row>
				<b-col lg="6">
					<b-img class="mt-5" v-if="apartment.urlImagenDelBienAComercializarUno" :src="'https://s3.amazonaws.com/gestion.mobysuite/'+apartment.urlImagenDelBienAComercializarUno" fluid></b-img>
				</b-col>
				<b-col lg="6">
					<b-button v-for="(type, key) in types" variant="outline-bravoizq" v-bind:key="'type'+key" @click="filterDorm(type)" :class="{'mx-1': true, 'active': type.active }">
						{{type.text}}
					</b-button>
					<b-table-simple borderless>
						<b-tr>
							<b-td colspan="2" class="py-0 pt-3">		
								<h4>Elige tu departamento</h4>
							</b-td>
						</b-tr>
						<b-tr>
							<b-th colspan="2"  class="py-0">
								<multiselect :allow-empty="false" class="multiselect-sm" v-model="selectedApartment" :options="filteredApartments" :close-on-select="true" :show-labels="false" placeholder="Departmento" track-by="value" label="text" @input="setapartment">
									<template slot="noOptions">No hay departamentos disponibles.</template>
								</multiselect>
							</b-th>
						</b-tr>
					<template v-if="selectedApartment">
							<b-tr v-if="parkings.length > 0 && (selectedApartment.numeroDeDormitorios > 1 || project_id != 'iq')">
								<b-td colspan="2" class="py-0 pt-3">		
									Elige tu estacionamiento
								</b-td>
							</b-tr>
							<b-tr v-if="parkings.length > 0 && (selectedApartment.numeroDeDormitorios > 1 || project_id != 'iq')">
								<b-th colspan="2"  class="py-0">
									<multiselect :allow-empty="true" class="multiselect-sm" v-model="selectedParking" :options="parkings" :close-on-select="true" :show-labels="true" placeholder="Seleccionar" track-by="id" label="text" deselect-label="Eliminar selección" select-label="" selected-label="Seleccionado">
									<template slot="noOptions">No hay elementos disponibles.</template>
									</multiselect>
								</b-th>
							</b-tr>
							<b-tr v-if="cellars.length > 0 && (selectedApartment.numeroDeDormitorios > 1 || project_id != 'iq')">
								<b-td colspan="2" class="py-0 pt-3">		
									Elige tu bodega
								</b-td>
							</b-tr>
							<b-tr v-if="cellars.length > 0 && (selectedApartment.numeroDeDormitorios > 1 || project_id != 'iq')">
								<b-th colspan="2"  class="py-0">
									<multiselect :allow-empty="true" class="multiselect-sm" v-model="selectedCellar" :options="cellars" :close-on-select="true" :show-labels="true" placeholder="Seleccionar" track-by="id" label="text" deselect-label="Eliminar selección" select-label="" selected-label="Seleccionado">
										<template slot="noOptions">No hay elementos disponibles.</template>
									</multiselect>
								</b-th>
							</b-tr>
						</template>
						<b-tr>
							<b-td width="10px" class="py-0 pt-3">
								<font-awesome-icon :icon="['fal', 'bed']" size="lg" />
							</b-td>
							<b-td>
								{{apartment.numeroDeDormitorios}} dormitorio{{(apartment.numeroDeDormitorios > 1 ? "s" : "")}}
							</b-td>
						</b-tr>
						<b-tr>
							<b-td class="py-0 pt-3">
								<font-awesome-icon :icon="['fal', 'bath']" size="lg" />
							</b-td>
							<b-td>
								{{apartment.numeroDeBanos}} baño{{(apartment.numeroDeBanos > 1 ? "s" : "")}}
							</b-td>
						</b-tr>
						<b-tr>
							<b-td colspan="2" class="py-0 pt-3">
								Superficie Total
							</b-td>
						</b-tr>
						<b-tr>
							<b-th colspan="2" class="py-0">
								{{apartment.superficieTotal | numberFormat}} m<sup>2</sup>
							</b-th>
						</b-tr>
						<b-tr>
							<b-td colspan="2" class="py-0 pt-3">
								Superficie Útil
							</b-td>
						</b-tr>
						<b-tr>
							<b-th colspan="2" class="py-0">
								{{apartment.superficieUtil | numberFormat }} m<sup>2</sup>
							</b-th>
						</b-tr>
						<b-tr>
							<b-td colspan="2" class="py-0 pt-3">
								Superficie Terraza
							</b-td>
						</b-tr>
						<b-tr>
							<b-th colspan="2" class="py-0">
								{{apartment.superficieTerraza | numberFormat}} m<sup>2</sup>
							</b-th>
						</b-tr>
					</b-table-simple>
					<b-row no-gutters class="mt-5 mb-3">
						<b-col cols="12" sm="9" class="pr-2 mt-1">
							<b-button v-b-modal.modal-quote block size="lg" variant="bravoizq" class="text-uppercase">Cotizar</b-button>
						</b-col>
						<b-col cols="12" sm="3" class="pr-2 mt-1">
							<b-button @click="goTo('project', { project_id: project.url })" block size="lg" variant="outline-dark" class="text-uppercase">Volver</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-container>
		<b-modal :hide-footer="true" id="modal-quote" centered title="Solicitud de Cotización" header-bg-variant="dark" header-text-variant="light" :no-enforce-focus="true" @hidden="cleanModal()">
			<div v-if="showResponse">
				<h4 class="text-center mb-4 text-bold">¡Gracias por cotizar con nosotros!</h4>
				<p class="px-3 text-justify">
					Hemos enviado a tu email el detalle de la cotización que realizaste en el proyecto <span class="text-bold">{{project.name}}</span>, aunque también puedes verlo en el siguiente enlace.
				</p>
				<p class="my-4 px-3 text-center">
					<b-button variant="bravoizq" :href="quoteResponse.document" target="_blank" >Ver cotización aquí</b-button>
				</p>
				<p class="px-3 text-justify">
					Hemos generado el código de reserva <span class="text-bold">{{quoteResponse.code}}</span> caso de que quieras reservar, puedes hacerlo de inmediato presionando en este link.
				</p>
				<p class="my-4 px-3 text-center">
					<b-button variant="bravoizq" :href="'https://reserva.mobysuite.com/bravoizquierdo/proyecto/'+project.project_name+'?code='+quoteResponse.code" target="_blank" >Reservar aquí</b-button>
				</p>
			</div>
			<div v-else>
				<h4 v-if="apartment" class="text-center"><b>{{apartment.tipoBien}} {{apartment.numeroDeBien}}</b></h4>
				<b-form-group label="Rut o DNI">
					<b-form-checkbox v-model="chilean"> Eres Chileno?</b-form-checkbox>
					<b-form-input v-model.trim="$v.quote.rut.$model" @keyup="formatRut" :state="$v.quote.rut.$dirty ? !$v.quote.rut.$error : null"></b-form-input>
					<b-form-invalid-feedback>
						Rut Inválido.
					</b-form-invalid-feedback>
				</b-form-group>
				<b-form-group label="Nombres">
					<b-form-input v-model.trim="$v.quote.name.$model" :state="$v.quote.name.$dirty ? !$v.quote.name.$error : null"></b-form-input>
					<b-form-invalid-feedback>
						El nombre debe contener al menos {{$v.quote.name.$params.minLength.min}} caracteres.
					</b-form-invalid-feedback>
				</b-form-group>
				<b-form-group label="Apellidos">
					<b-form-input v-model.trim="$v.quote.lastname.$model" :state="$v.quote.lastname.$dirty ? !$v.quote.lastname.$error : null"></b-form-input>
					<b-form-invalid-feedback>
						El apellido debe contener al menos {{$v.quote.lastname.$params.minLength.min}} caracteres.
					</b-form-invalid-feedback>
				</b-form-group>
				<b-form-group label="Teléfono">
					<vue-tel-input @input="checkPhone" wrapperClasses="form-control cellphone-input"></vue-tel-input>
					<b-form-input class="d-none" v-model="$v.quote.cellphone.$model" :state="$v.quote.cellphone.$dirty ? !$v.quote.cellphone.$error : null"></b-form-input>
					<b-form-invalid-feedback>
						Teléfono invalido.
					</b-form-invalid-feedback>
				</b-form-group>
				<b-form-group label="Email">
					<b-form-input v-model.trim="$v.quote.email.$model" :state="$v.quote.email.$dirty ? !$v.quote.email.$error : null"></b-form-input>
					<b-form-invalid-feedback>
						Email inválido.
					</b-form-invalid-feedback>
				</b-form-group>
				<b-col cols="12" class="text-center">
					<b-button size="lg" block class=" mt-5 pl-5 pr-5" variant="outline-dark" @click="send" >¡Solicitar!</b-button>
				</b-col>
			</div>
		</b-modal>
		<loading :active.sync="isLoading" :z-index="9999" :is-full-page="true" color="#B12424" :height="100" :width="100"></loading>
	</div>
</template>
<script>
	import NavBarProject from '../../../components/NavBarProject.vue';
	import Loading from 'vue-loading-overlay';
	import { required, minLength, email } from "vuelidate/lib/validators";
	//import { isRutValid } from "validators";
	export default {
		name: 'quote',
		props: {
			project_id: {default: null}
		},
		data(){
			return{
				token_api: '3EE138B-E0F96084F141FF01-429D85DD274D80D057D02D15485D9-4C784ABD2D5C',
				isLoading: false,
				showResponse: false,
				project: null,
				apartments: null,
				complementary: null,
				selectedCellar: null,
				selectedParking: null,
				selectedComplementary: null,
				complementaryList: [],
				parkings: [],
				cellars: [],
				types: null,
				filteredApartments: null,
				apartment: null,
				selectedApartment: null,
				chilean: true,
				quote: {
					customer_name: 'bravoizquierdo',
					project_name: null,
					project_id: null,
					name: null,
					lastname: null,
					email: null,
					cellphone: null,
					rut: null,
					assets: []
				},
				quoteResponse: {
					code: null
				}
			}
		},
		validations() {
			if(this.chilean){
				return{
					quote:{
						rut: { required, RutValid: isRutValid },
						name: { required, minLength: minLength(3) },
						lastname: { required, minLength: minLength(3) },
						email: { required, email },
						cellphone: { required, minLength: minLength(9) },
					}
				}
			}else{
				return{
					quote:{
						rut: { required: false },
						name: { required, minLength: minLength(3) },
						lastname: { required, minLength: minLength(3) },
						email: { required, email },
						cellphone: { required, minLength: minLength(9) },
					}
				}
			}
		},
		components: {
			NavBarProject,
			Loading
		},
		mounted(){
			this.$root.captureUtm();
			this.$root.sessionStorageSet('utm_dhunter','inmobiliariabi');			
		},
		beforeMount() {
			this.project = this.$store.getters.getProjectByUrl(this.project_id);
			if(this.project){
				this.setQuote()
			}else{
				this.$store.commit('setProjects');
			}
		},
		methods: {
			goTo(url, params){
				this.$router.push({ name: url, params: params }).catch(err => { console.log('ERROR:',err) });
			},
			setQuote(){
				let self = this;
				this.quote.project_name = this.project.project_name;
				this.quote.project_id = this.project.project_id;
				this.isLoading = true;
				this.axios.get("quotes/"+this.project.project_id+"/get_assets").then(result => {
					self.isLoading = false;
					self.apartments = result.data.assets;
					self.cellars = result.data.complementary.storage;
					self.parkings = result.data.complementary.parking;
					var uniqueTypes = self.apartments.map( obj => obj.numeroDeDormitorios ).filter((elem, pos, arr) => arr.indexOf(elem) == pos).sort();
					let studioItems = self.apartments.filter(obj => obj.tipo == "STUDIO");
					var first = true;
					if(studioItems.length > 0){
						self.types = [{value: "STUDIO", text: "STUDIO", active: true}].concat(uniqueTypes.map( obj => {
								var elem = {
									value: obj,
									text: obj + " dormitorio"+(obj > 1 ? "s" : ""),
									numeroDeDormitorios: obj.numeroDeDormitorios,
									active: first
								};
								first = false;
								return elem;
							}
						))
					}else{
						self.types = uniqueTypes.map( obj => {
								var elem = {
									value: obj,
									text: obj + " dormitorio"+(obj > 1 ? "s" : ""),
									numeroDeDormitorios: obj.numeroDeDormitorios,
									active: first
								};
								first = false;
								return elem;
							}
						)
					}
					self.filterDorm(self.types[0])
				}).catch(error => {
					self.isLoading = false;
					console.log(error)
				});
			},
			filterDorm(type){
				this.types.map( obj => obj.active = false);
				type.active = true;
				if(type.value == "STUDIO"){
					this.filteredApartments = this.apartments.filter((elem) => elem.tipo == "STUDIO").map( obj => {
						var elem = {
							value: obj.id,
							text: obj.tipoBien + " "+obj.numeroDeBien+ " | "+obj.numeroDeDormitorios+"D - "+obj.numeroDeBanos+"B",
							numeroDeDormitorios: obj.numeroDeDormitorios,
							active: false
						};
						return elem;
					})
				}else{
					this.filteredApartments = this.apartments.filter((elem) => elem.numeroDeDormitorios == type.value && elem.tipo != "STUDIO").map( obj => {
						var elem = {
							value: obj.id,
							text: obj.tipoBien + " "+obj.numeroDeBien+ " | "+obj.numeroDeDormitorios+"D - "+obj.numeroDeBanos+"B",
							numeroDeDormitorios: obj.numeroDeDormitorios,
							active: false
						};
						return elem;
					})
				}
				
				this.selectedApartment = this.filteredApartments[0]
				this.setapartment(this.selectedApartment)
			},
			removeComplementary(k, complementary){
				this.complementaryList.splice(k,1)
				let keyQuote = this.quote.assets.indexOf(complementary.id);
				this.quote.assets.splice(keyQuote,1)
			},
			setapartment(event){
				this.apartment = this.apartments.find((elem) => elem.id == event.value)
				//this.quote.assets = [event.value]
				this.complementaryList = []
			},
			setComplementary(event){
				this.selectedComplementary = null;
				if(!(this.quote.assets.find((elem) => elem == event.id))){
					this.complementaryList.push(event)
					this.quote.assets.push(event.id)
				}
			},
			digito(rut, dv) {
				let suma = 0;
				let multiplicador = 2;
				while (rut !== 0) {
					if (multiplicador === 8) {
						multiplicador = 2;
					}
					suma += (rut % 10) * multiplicador;
					rut = Math.trunc(rut / 10);
					multiplicador++;
				}
				suma = 11 - (suma % 11);
				switch (suma) {
					case 11:
						return ("0" === dv);
					case 10:
						return ("K" === dv.toUpperCase());
					default:
						return (suma.toString() === dv);
				}
			},
			formatRut(){
				if(this.chilean){
					if(this.quote.rut.length > 0){
						this.quote.rut = this.quote.rut.replace(/[^\dKk]/g, '');
						let dato = this.quote.rut;
						let largo = dato.length;
						if (largo === 1) {
							this.dv = dato;
							this.quote.rut = '';
							this.digito(this.quote.rut, this.dv);
							this.formato()
						} else if (largo > 1) {
							this.dv = dato.substring(largo - 1);
							this.quote.rut = dato.substring(largo - 1, 0);
							this.digito(this.quote.rut, this.dv);
							this.formato()
						}
					}
				}else{
					return true
				}
			},
			formato() {
				let rut = (this.quote.rut) ? (new Intl.NumberFormat("es-CL").format(parseInt(this.quote.rut))) + '-' : '';
				this.quote.rut = rut + this.dv;
			},
			send(){
				let self = this;
				this.quote.assets  = [this.selectedApartment.value]
				if(this.selectedApartment.numeroDeDormitorios > 1 || this.project_id != 'iq'){
					if(this.selectedParking){
						this.quote.assets.push(this.selectedParking.id);
					}
					if(this.selectedCellar){
						this.quote.assets.push(this.selectedCellar.id);
					}
				}
				this.$v.quote.$touch()
				if(!this.$v.quote.$invalid){
					this.isLoading = true;
					this.axios.post("quotes", {customer_id: 'bravoizquierdo', id: this.project.project_name, quote: this.quote}).then(result => {
						self.quoteResponse = result.data
						self.isLoading = false;
						self.showResponse = true;

						/* DHUNTER*/		
					
						let origen = sessionStorage.getItem('utm_dhunter').toUpperCase().replace(/,/g, "-");

						let id_proyect_dh = {
							3:167, //CU Apartments
							2:164, //Connection
							//4:166, //Mares de Montemar
							1:165,  //Punta Pacífico
							5:246, //IQ
							4:257, //VM
						};

						console.log('DH:'+id_proyect_dh[this.quote.project_id]);
				
						let data = {
							quote:this.quote,
							customer_id: 'bravoizquierdo',
							id: this.project.project_name,
							token_api: this.token_api,
							nombre_planta: this.selectedApartment.text,
							rut: this.quote.rut,
							telefono: this.quote.cellphone,
							nombre: this.quote.name,
							apellido: this.quote.lastname,
							email: this.quote.email,			
							id_proyecto: id_proyect_dh[this.quote.project_id],
							tipo: 1,
							mensaje: 'inmobiliariabi',
							origen: origen			
						};
										
						this.axios.post('https://datahunter.cl/API/cotizacion_externa/registroCotizacion',data).then( ()=>{		

							switch(this.project_id)
							{
								case 'iq':					
									//this.$ga('event', 'conversion', {'send_to': 'AW-650047078/M_LfCOyc8IsDEObc-7UC'});
									this.$ga.event('conversion', 'send_to', 'AW-650047078/M_LfCOyc8IsDEObc-7UC');
								break;	
								case 'vm':
									//this.$ga('event', 'conversion', {'send_to': 'AW-650047078/Sg3oCO3Zx4sDEObc-7UC'});
									this.$ga.event('conversion', 'send_to', 'AW-650047078/Sg3oCO3Zx4sDEObc-7UC');
								break;
								case 'cu':
									//this.$ga('event', 'conversion', {'send_to': 'AW-650047078/_NBmCI_Q8NkBEObc-7UC'});
									this.$ga.event('conversion', 'send_to', 'AW-650047078/_NBmCI_Q8NkBEObc-7UC');
								break;
								case 'connection':
									//this.$ga('event', 'conversion', {'send_to': 'AW-650047078/TIv9CLu-js4BEObc-7UC'});
									this.$ga.event('conversion', 'send_to', 'AW-650047078/TIv9CLu-js4BEObc-7UC');
								break;							
							}
																		
							self.isLoading = false;
							self.showResponse = true;
							
						}).catch(error =>{
							self.isLoading = false;
							console.log(error);
						})

					}).catch(error => {
						self.isLoading = false;
						console.log(error)
					});
				}
			},
			checkPhone(number, data) {
				if(number.length > 0){
					if(data.isValid){
						document.getElementsByClassName('cellphone-input')[0].classList.remove('is-invalid')
						document.getElementsByClassName('cellphone-input')[0].classList.add('is-valid')
						this.quote.cellphone = data.number.e164;
					}else{
						this.quote.cellphone = null;
						document.getElementsByClassName('cellphone-input')[0].classList.remove('is-valid')
						document.getElementsByClassName('cellphone-input')[0].classList.add('is-invalid')
					}
				}else{
					this.quote.cellphone = null;
					document.getElementsByClassName('cellphone-input')[0].classList.remove('is-valid')
					document.getElementsByClassName('cellphone-input')[0].classList.remove('is-invalid')
				}
			},
			cleanModal(){
				this.showResponse = false;
				this.quote.rut = null;
				this.quote.name = null;
				this.quote.lastname = null;
				this.quote.email = null;
				this.quote.cellphone = null;
				this.$v.quote.$reset();
			}
		},
		watch: {		
			'$store.state.projects': {
				handler: function()  {
					this.project = this.$store.getters.getProjectByUrl(this.project_id);
					if(this.project){
						this.setQuote();
					}
				}
			}
		}
	}
	export function isRutValid(value) {
		if (value == null) return false;
		if (value.length === 0) return false;
		var input = value.replace(/[^\dKk]/g, '');
		let dato = input;
		let largo = dato.length;
		if (largo === 1) {
			let dv = dato;
			let rut = '';
			return digito(rut, dv);
		} else if (largo > 1) {
			let dv = dato.substring(largo - 1);
			let rut = dato.substring(largo - 1, 0);
			return digito(rut, dv);
		} else {
			return false;
		}

		function digito(rut, dv) {
			let suma = 0;
			let multiplicador = 2;
			while (rut !== 0) {
				if (multiplicador === 8) {
					multiplicador = 2;
				}
				suma += (rut % 10) * multiplicador;
				rut = Math.trunc(rut / 10);
				multiplicador++;
			}
			suma = 11 - (suma % 11);
			switch (suma) {
				case 11:
					return ("0" === dv);
				case 10:
					return ("K" === dv.toUpperCase());
				default:
					return (suma.toString() === dv);
			}
		}
	}
</script>
